(function($, Drupal) {
  Drupal.behaviors.navigation = {
    attach: function(context, settings) {
      // ---- TUCK NAVIGATION ---- //
      if ($(window).width() > 1130) {
        let position, scroll;
        const global_navigation = document.getElementById('global-navigation');

        position = window.scrollY;

        // Listen to scroll
        window.addEventListener('scroll', () => {
          scroll = window.scrollY;
          if (scroll > position && !global_navigation.classList.contains('nav-open') && window.scrollY > 100) {
            global_navigation.classList.add('tucked');
          }
          else if (scroll < position && global_navigation.classList.contains('tucked')) {
            global_navigation.classList.remove('tucked');
            global_navigation.classList.add('tucked-white');
          }

          if (window.scrollY < 100) {
            global_navigation.classList.remove('tucked-white');
          }

          position = scroll;
        });

        if (position !== 0) {
          global_navigation.classList.add('tucked-white');
        }
      }

      // Script runs on admin pages so layout is not compromised by the fixed navigation present on the homepage
      if ($('.node-homepage-layout-builder-form').length !== 0) {
        $('.global-header').addClass('not-fixed');
      }

      // ---- MEGA MENU DROPDOWNS AND DRAWERS ---- //
      // Declare variables
      let $header,
          $header_items,
          $primary_menu,
          $nav_sololinks,
          $nav_toggles,
          $nav_sub_toggles,
          $grandsub_nav_toggles,
          $nav_back,
          $sub_nav_back,
          $grandsub_nav_sub_back,
          $dropdown_wrap;

      const $html = $('html', context);
      const $body = $('body', context);
      const $mobile_menu_toggle = $('#js-nav-toggle', context);

      // Header variables
      $header = $('header');
      $header_items = $('header *');

      // Mega menu toggle variables
      $nav_sololinks = $('.primary-nav-item > a', context);
      $primary_menu = $('.primary-menu', context);
      $dropdown_wrap = $('.dropdown-wrap', context);

      // Dropdown triggers
      $nav_toggles = $('.js-toggle-dropdown-menu', context);
      $nav_sub_toggles = $('.js-toggle-drawer-menu', context);
      $grandsub_nav_toggles = $('.js-toggle-grand-drawer-menu', context);

      // Back button triggers, only accesible on mobile
      $nav_back = $('.js-mobile-menu-back', context);
      $sub_nav_back = $('.js-mobile-sub-menu-back', context);
      $grandsub_nav_sub_back = $('.js-mobile-grand-sub-menu-back', context);

      // Wraps menu items until a sub group item
      function wrapSubGroups(id) {
        let $menu_items_sub_groups = $('#dropdown-menu-' + id).find('> .group');
        $menu_items_sub_groups.once('wrap-sub-groups').each(function(index) {
          if (index < $menu_items_sub_groups.length - 1) {
            $(this).attr('id', 'group-' + index + id);
            let $menu_items_to_wrap = $('#group-' + index + id).nextUntil('li.group').addBack();
            $menu_items_to_wrap.wrapAll('<li class="menu-item-grouped"><ul class="subgroup-list"></ul></li>');
          }
        });

        let $menu_items_left_over = $('#dropdown-menu-' + id + ' > .menu-item');
        $menu_items_left_over.once('wrap-leftovers').each(function(index) {
          for (let i = 0; i < $menu_items_left_over.length; i += 5) {
            $menu_items_left_over.once('wrap-leftovers-wrap').slice(i, i + 5).wrapAll('<li class="menu-item-grouped"><ul class="subgroup-list"></ul></li>');
          }
        });

        $menu_items_left_over = $('#dropdown-menu-' + id + ' > .menu-item');
        $('#dropdown-menu-' + id + ' > .menu-item').wrapAll('<li class="menu-item-grouped"><ul class="subgroup-list"></ul></li>');
      }

      // Appends IDs to dropdown menus
      $(function() {
        let $dropdown_menu_wrap = $('.dropdown-menu-wrap');
        // Group menu items that dont belong to a group
        $dropdown_menu_wrap.each(function(index) {
          $(this).attr('id', 'dropdown-menu-' + index);

          if ($('#dropdown-menu-' + index).find('.group').length !== 0) {
            wrapSubGroups(index);
          }
        });
      });

      // Mobile Nav toggle
      $mobile_menu_toggle.once('navigation-mobile').on('click', function() {
        if ($(this).hasClass('active')) {
          // Close any open sub menus after nav drawer is closed
          $(this).removeClass('active');
          $primary_menu.slideUp(300, function() {
            $('.dropdown-close').removeClass('dropdown-open');
          });
          $html.removeClass('no-scroll');
          $body.removeClass('no-scroll');
        }
        else {
          $(this).addClass('active');
          // Close any open sub menus after nav drawer is closed
          $primary_menu.slideDown(300);
          $(window).scrollTop(0);
          $html.addClass('no-scroll');
          $body.addClass('no-scroll');
        }
        $header.toggleClass('header-fixed');
        // $('.dropdown-open').addClass('dropdown-close');
      });

      $nav_toggles.once('check-open').on('focus', function() {
        $nav_toggles.removeClass('dropdown-open');
        $nav_toggles.removeClass('pseudo-desktop-open');
        $('.dropdown-wrap').slideUp(300);
      });

      // Closes dropdown when last items is tabbed off of
      let $last_link = $('#primary-menu .dropdown-menu-wrap .menu-item', context).last().find('a').first();
      $last_link.keydown(function(e) {
        if (e.code === 'Tab') {
          if (!e.shiftKey) {
            $nav_toggles.removeClass('dropdown-open');
            $('.dropdown-wrap').slideUp(300);
          }
        }
      });

      $nav_sololinks.once('check-open-links').on('focus', function() {
        $nav_toggles.removeClass('dropdown-open');
        $('.dropdown-wrap').slideUp(300);
      });

      // Dropdown menu accordion logic
      $nav_toggles.once('navigation-main').on('click', function(event) {
        event.stopPropagation();
        // Close all other super menus
        $nav_toggles.not($(this)).removeClass('dropdown-open');
        $nav_toggles.removeClass('pseudo-desktop-open');
        $(this).removeClass('dropdown-close');

        if (!$(this).hasClass('dropdown-open')) {
          $(this).addClass('dropdown-open');
          $(window).scrollTop(0);
          $('#global-navigation').addClass('nav-open');
        }
        else {
          $(this).removeClass('dropdown-open');
          $('#global-navigation').removeClass('nav-open');
        }

        if ($(window).width() > 1130) {
          $nav_toggles.not($(this)).next('.dropdown-wrap').slideUp(300);
          $(this).next('.dropdown-wrap').slideToggle(300);
        }
      });

      // Open sub menu drawers on mobile
      $nav_sub_toggles.once('navigation-main-sub').on('click', function(event) {
        event.stopPropagation();
        // Close all other super menus
        $nav_sub_toggles.not($(this)).removeClass('dropdown-open');
        $(this).removeClass('dropdown-close');

        if (!$(this).hasClass('dropdown-open')) {
          $(this).addClass('dropdown-open');
        }
        else {
          $(this).removeClass('dropdown-open');
        }
      });

      // Grandsub menu accordion logic
      $grandsub_nav_toggles.once('navigation-main-grand').on('click', function(event) {
        event.stopPropagation();
        // Close all other super menus
        $grandsub_nav_toggles.not($(this)).removeClass('dropdown-open');
        $(this).removeClass('dropdown-close');

        if (!$(this).hasClass('dropdown-open')) {
          $(this).addClass('dropdown-open');
        }
        else {
          $(this).removeClass('dropdown-open');
        }
      });

      // Mobile menu back button logic, goes three levels deep
      $nav_back.once('navigation-submenu').on('click', function() {
        $(this).parent().prev('button').addClass('dropdown-close');
        $(this).parent().prev('button').removeClass('pseudo-desktop-open');
        setTimeout(function() {
          $header_items.removeClass('dropdown-open');
        }, 300);
      });

      $sub_nav_back.once('navigation-grand-submenu').on('click', function() {
        let $sub_back = $(this);
        $sub_back.parent().parent().prev('button').addClass('dropdown-close');
        $sub_back.parent().parent().prev('button').removeClass('pseudo-desktop-open');
        setTimeout(function() {
          $sub_back.parent().parent().prev('button').removeClass('dropdown-open');
        }, 300);
      });

      $grandsub_nav_sub_back.once('navigation-grand-submenu').on('click', function() {
        let $grand_back = $(this);
        $grand_back.parent().parent().prev('button').addClass('dropdown-close');
        $grand_back.parent().parent().prev('button').removeClass('pseudo-desktop-open');
        setTimeout(function() {
          $grand_back.parent().parent().prev('button').removeClass('dropdown-open');
        }, 300);
      });

      $(function() {
        if ($(window).width() > 1130) {
          $('.menu-item--active-trail').each(function() {
            $(this).find('.js-toggle-drawer-menu').trigger('click');
            $(this).find('.js-toggle-grand-drawer-menu').trigger('click');
          });
        }
      });

      // Reset and open items on window resize, with breakpoint being desktop view
      // Fire on resize
      $(window, context).once('navigation-resize').resize(function() {
        if ($(window).width() > 1130) {
          $html.removeClass('no-scroll');
          $body.removeClass('no-scroll');
          $header.removeClass('header-fixed');
          $nav_toggles.removeClass('dropdown-open');
          $primary_menu.removeAttr('style');
          $dropdown_wrap.removeAttr('style');
        }
      });

      // Close nav if click outside of menu detected
      $(document).on('click', function(event) {
        if ($(window).width() > 1130) {
          let container = $('.dropdown-wrap');
          // if the target of the click isn't the container nor a descendant of the container
          if (!container.is(event.target) && container.has(event.target).length === 0) {
            container.slideUp(300);
            $('.nav-open').removeClass('nav-open');
            $('.dropdown-open').removeClass('dropdown-open');
          }
        }
      });
    }
  };
})(jQuery, Drupal);
